import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../lib/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  leftAdornment?: React.ReactNode;
  rightAdornment?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", error, leftAdornment, rightAdornment, ...props }, ref) => {
    const hasAdornment = leftAdornment || rightAdornment;
    const inputContent = (
      <input
        ref={ref}
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-1.5 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
          error && "border-destructive ring-destructive/20 focus-visible:ring-destructive/30",
          leftAdornment && "pl-10",
          rightAdornment && "pr-10",
          className,
        )}
        {...props}
      />
    );

    if (hasAdornment) {
      return (
        <div className="relative w-full">
          {leftAdornment && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 flex items-center justify-center text-muted-foreground">
              {leftAdornment}
            </div>
          )}
          {inputContent}
          {rightAdornment && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center justify-center text-muted-foreground">
              {rightAdornment}
            </div>
          )}
        </div>
      );
    }

    return inputContent;
  }
);
Input.displayName = "Input";
